import { AudioData, Chord, ClassicWaveform, dbToGain, FFT, gainToDb, Interpolation, midiToHz, Mixing, PPQN, WavFile } from "@opendaw/lib-dsp";
import { AudioSendRouting, TransientPlayMode, VoicingMode } from "@opendaw/studio-enums";
import { ApiImpl } from "./impl/ApiImpl";
export var ScriptGlobals;
(function (ScriptGlobals) {
    ScriptGlobals.create = (api, context) => ({
        ...context,
        openDAW: api,
        AudioData, WavFile, midiToHz, PPQN, FFT, Chord, Interpolation, dbToGain, gainToDb,
        ClassicWaveform, VoicingMode, Mixing, TransientPlayMode, AudioSendRouting
    });
})(ScriptGlobals || (ScriptGlobals = {}));
export class ScriptRunner {
    #api;
    constructor(protocol) { this.#api = new ApiImpl(protocol); }
    get api() { return this.#api; }
    async run(jsCode, context) {
        Object.assign(globalThis, ScriptGlobals.create(this.#api, context));
        // Runs as a function body, not a module, so a script may `return` early
        const AsyncFunction = (async () => { }).constructor;
        await new AsyncFunction(jsCode.replace(/^\s*export\s*\{\s*\};?/m, ""))();
    }
}
